import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Domain/components/Shared/Select/Select';

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language || 'en';

  const handleChangeLanguage = (lng: string) => {
    localStorage.setItem('__qc_i18nextLng', lng);
    i18n.changeLanguage(lng);
  };

  const languages = useMemo(
    () => [
      { code: 'en', label: 'English' },
      { code: 'pl', label: 'Polski' },
      { code: 'de', label: 'Deutsch' },
      { code: 'fr', label: 'Français' },
      { code: 'es', label: 'Español' },
      { code: 'pt', label: 'Português' },
      { code: 'ja', label: '日本語' },
      { code: 'sv', label: 'Svenska' },
    ],
    [t],
  );

  return (
    <Select value={currentLanguage} onValueChange={handleChangeLanguage}>
      <SelectTrigger className="min-w-[120px] h-[39px]">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent>
        {languages.map(({ code, label }) => (
          <SelectItem key={code} value={code}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
